import { LoginForm } from "./LoginForm";

export function Login() {

    return (
        <LoginForm />
    )
}
